"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PseudoType = void 0;
var PseudoType;
(function (PseudoType) {
    PseudoType["IntlFormatterFormat"] = "INTLFM_F";
    PseudoType["IntlFM"] = "INTL_FM";
    PseudoType["IntlFN"] = "INTL_FN";
    PseudoType["IntlFD"] = "INTL_FD";
    PseudoType["HardCoded"] = "HARD_CODED";
    PseudoType["Assess"] = "ASSESS";
    PseudoType["Decentralized"] = "DECENTRALIZED";
    PseudoType["Backdoor"] = "BACKDOOR";
    PseudoType["IntlFMWFL"] = "INTL_FMWFL";
    PseudoType["Clean"] = "CLEAN";
    PseudoType["Garbl"] = "GARBL";
    PseudoType["Stretched"] = "STRETCHED";
    PseudoType["Superscript"] = "SUPERSCRIPT";
    PseudoType["Accents"] = "ACCENTS";
    PseudoType["Strike"] = "STRIKE";
    PseudoType["Tilde"] = "TILDE";
    PseudoType["Kanji"] = "KANJI";
    PseudoType["Arrows"] = "ARROWS";
    PseudoType["Wavy"] = "WAVY";
    PseudoType["Dont"] = "DONT";
    PseudoType["Numbers"] = "NUMBERS";
    PseudoType["Slash"] = "SLASH";
    PseudoType["Dates"] = "DATES";
    PseudoType["Crosses"] = "CROSSES";
    PseudoType["MicroCode"] = "MICROCODE";
})(PseudoType = exports.PseudoType || (exports.PseudoType = {}));
//# sourceMappingURL=pseudoizers.js.map